'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _NeutralBrandingRoutes = require('../../helpers/NeutralBrandingRoutes');

var _ConfirmForgotPass = require('./ConfirmForgotPass.scss');

var _ConfirmForgotPass2 = _interopRequireDefault(_ConfirmForgotPass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmForgotPass = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ConfirmForgotPass, _Component);

  function ConfirmForgotPass() {
    (0, _classCallCheck3.default)(this, ConfirmForgotPass);
    return (0, _possibleConstructorReturn3.default)(this, (ConfirmForgotPass.__proto__ || (0, _getPrototypeOf2.default)(ConfirmForgotPass)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConfirmForgotPass, [{
    key: 'render',
    value: function render() {
      var emailAddress = this.props.auth && this.props.auth.email;
      var isNeutralRoute = (0, _NeutralBrandingRoutes.isNeutralBrandingRoute)(this.context.router.location.pathname);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_ConfirmForgotPass2.default.confirmForgotPass, { stingrayCorpo: isNeutralRoute }) },
        _react2.default.createElement(_components.DialogCard, {
          title: _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.PasswordResetTitle),
          message: _react2.default.createElement(
            'div',
            { className: _ConfirmForgotPass2.default.message },
            emailAddress ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _DefaultString.translations.ConfirmForgotPasswordMessage, {
              values: { email: emailAddress }
            })) : '',
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ConfirmForgotPasswordSubMessage)
          )
        }),
        _react2.default.createElement(_components.BrandLogos, null)
      );
    }
  }]);
  return ConfirmForgotPass;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = (0, _reactIntl.injectIntl)(ConfirmForgotPass);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConfirmForgotPass/ConfirmForgotPass.js
// module id = 2001
// module chunks = 0